import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuthApi } from '../hooks/use-auth-api';

const ExperienceAdd: React.FC = () => {
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuthApi();
  const [saving, setSaving] = useState(false);
  const [toast, setToast] = useState<{ message: string; type: 'success' | 'error' } | null>(null);
  const [formData, setFormData] = useState({
    title: '',
    product_type: '',
    challenge: '',
    questions: '',
    solution: ''
  });

  const showToast = (message: string, type: 'success' | 'error') => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 4000);
  };

  // ── بررسی احراز هویت ──────────────────────────────────
  if (!isAuthenticated || !user) {
    return (
      <div style={{ direction: 'rtl', padding: '50px', textAlign: 'center' }}>
        <h2>⚠️ لطفاً ابتدا وارد شوید</h2>
        <Link to="/login" style={{ color: '#2e7d32' }}>رفتن به صفحه ورود</Link>
      </div>
    );
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.title || !formData.challenge) {
      showToast('عنوان و چالش الزامی است', 'error');
      return;
    }

    setSaving(true);

    try {
      const payload = {
        title: formData.title,
        product_type: formData.product_type,
        challenge: formData.challenge,
        questions: formData.questions,
        solution: formData.solution
      };

      console.log('📤 ارسال تجربه:', payload);

      const response = await fetch('https://fellfell.ir/api/experiences.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(payload)
      });

      const data = await response.json();
      console.log('📨 پاسخ:', data);

      if (data.success) {
        showToast('✅ تجربه با موفقیت ثبت شد و در انتظار تایید است', 'success');
        setTimeout(() => {
          navigate('/experiences');
        }, 2000);
      } else {
        showToast('❌ خطا در ثبت تجربه: ' + (data.message || 'خطای نامشخص'), 'error');
      }
    } catch (err: any) {
      console.error('❌ خطا:', err);
      showToast('❌ خطا در ارتباط با سرور: ' + err.message, 'error');
    }

    setSaving(false);
  };

  return (
    <div style={{ direction: 'rtl', padding: '20px', maxWidth: '700px', margin: '0 auto' }}>
      {toast && (
        <div style={{
          position: 'fixed',
          top: '20px',
          left: '50%',
          transform: 'translateX(-50%)',
          padding: '14px 28px',
          borderRadius: '12px',
          fontSize: '15px',
          zIndex: 9999,
          background: toast.type === 'success' ? '#2e7d32' : '#c62828',
          color: '#fff',
          boxShadow: '0 6px 25px rgba(0,0,0,0.25)',
          animation: 'slideDown 0.3s ease-out'
        }}>
          {toast.message}
        </div>
      )}

      <div style={{ background: '#fff', borderRadius: '16px', padding: '30px', boxShadow: '0 2px 10px rgba(0,0,0,0.06)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '25px' }}>
          <h1 style={{ color: '#1e3a1e', fontSize: '24px' }}>🌾 ثبت تجربه کشاورزی</h1>
          <Link to="/experiences" style={{ color: '#2e7d32', textDecoration: 'none' }}>
            ← بازگشت به لیست تجارب
          </Link>
        </div>

        <form onSubmit={handleSubmit}>
          {/* عنوان */}
          <div style={{ marginBottom: '18px' }}>
            <label style={{ display: 'block', fontWeight: '600', marginBottom: '6px', fontSize: '14px' }}>
              عنوان تجربه <span style={{ color: '#d32f2f' }}>*</span>
            </label>
            <input
              type="text"
              value={formData.title}
              onChange={e => setFormData({ ...formData, title: e.target.value })}
              style={{ width: '100%', padding: '11px 14px', borderRadius: '10px', border: '2px solid #ddd', fontSize: '15px' }}
              placeholder="مثلاً: تجربه کاشت گوجه فرنگی در گلخانه"
              required
            />
          </div>

          {/* نوع محصول */}
          <div style={{ marginBottom: '18px' }}>
            <label style={{ display: 'block', fontWeight: '600', marginBottom: '6px', fontSize: '14px' }}>
              نوع محصول
            </label>
            <input
              type="text"
              value={formData.product_type}
              onChange={e => setFormData({ ...formData, product_type: e.target.value })}
              style={{ width: '100%', padding: '11px 14px', borderRadius: '10px', border: '2px solid #ddd', fontSize: '15px' }}
              placeholder="مثلاً: گوجه فرنگی، خیار، گندم"
            />
          </div>

          {/* چالش */}
          <div style={{ marginBottom: '18px' }}>
            <label style={{ display: 'block', fontWeight: '600', marginBottom: '6px', fontSize: '14px' }}>
              چالش <span style={{ color: '#d32f2f' }}>*</span>
            </label>
            <textarea
              value={formData.challenge}
              onChange={e => setFormData({ ...formData, challenge: e.target.value })}
              rows={4}
              style={{ width: '100%', padding: '11px 14px', borderRadius: '10px', border: '2px solid #ddd', fontSize: '15px', resize: 'vertical' }}
              placeholder="چالشی که با آن مواجه شدید را توضیح دهید..."
              required
            />
          </div>

          {/* سوالات */}
          <div style={{ marginBottom: '18px' }}>
            <label style={{ display: 'block', fontWeight: '600', marginBottom: '6px', fontSize: '14px' }}>
              سوالات
            </label>
            <textarea
              value={formData.questions}
              onChange={e => setFormData({ ...formData, questions: e.target.value })}
              rows={3}
              style={{ width: '100%', padding: '11px 14px', borderRadius: '10px', border: '2px solid #ddd', fontSize: '15px', resize: 'vertical' }}
              placeholder="سوالاتی که در این مسیر داشتید..."
            />
          </div>

          {/* راه‌حل */}
          <div style={{ marginBottom: '22px' }}>
            <label style={{ display: 'block', fontWeight: '600', marginBottom: '6px', fontSize: '14px' }}>
              راه‌حل
            </label>
            <textarea
              value={formData.solution}
              onChange={e => setFormData({ ...formData, solution: e.target.value })}
              rows={4}
              style={{ width: '100%', padding: '11px 14px', borderRadius: '10px', border: '2px solid #ddd', fontSize: '15px', resize: 'vertical' }}
              placeholder="راه‌حلی که برای این چالش پیدا کردید..."
            />
          </div>

          {/* دکمه‌ها */}
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', borderTop: '1px solid #eee', paddingTop: '20px' }}>
            <Link to="/experiences" style={{
              padding: '12px 24px',
              background: '#e0e0e0',
              color: '#333',
              textDecoration: 'none',
              borderRadius: '10px',
              fontSize: '15px',
              fontWeight: '500'
            }}>
              انصراف
            </Link>
            <button
              type="submit"
              disabled={saving}
              style={{
                padding: '12px 30px',
                background: '#2e7d32',
                color: '#fff',
                border: 'none',
                borderRadius: '10px',
                fontSize: '15px',
                fontWeight: '600',
                cursor: 'pointer',
                opacity: saving ? 0.6 : 1
              }}
            >
              {saving ? '⏳ در حال ثبت...' : '🌾 ثبت تجربه'}
            </button>
          </div>
        </form>

        <div style={{ marginTop: '20px', padding: '15px', background: '#f5faf5', borderRadius: '10px', fontSize: '13px', color: '#666' }}>
          <strong>📌 نکته:</strong> تجربه شما پس از ثبت، در انتظار تایید قرار می‌گیرد و پس از تایید در سایت نمایش داده می‌شود.
        </div>
      </div>

      <style>{`
        @keyframes slideDown {
          from { opacity: 0; transform: translateX(-50%) translateY(-20px); }
          to { opacity: 1; transform: translateX(-50%) translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default ExperienceAdd;